import { isClient } from '@vueuse/core'

export const rAF = (fn: () => void) =>
  isClient
    ? window.requestAnimationFrame(fn)
    : (setTimeout(fn, 16) as unknown as number)

export const cAF = (handle: number) =>
  isClient ? window.cancelAnimationFrame(handle) : clearTimeout(handle)

/**
 * Throttle function using requestAnimationFrame
 */
export const throttleByRaf = <T extends (...args: any[]) => any>(
  fn: T
): ((...args: Parameters<T>) => void) => {
  let rafId: number | null = null
  let lastArgs: Parameters<T>

  const throttled = (...args: Parameters<T>) => {
    lastArgs = args
    if (rafId === null) {
      rafId = rAF(() => {
        fn(...lastArgs)
        rafId = null
      })
    }
  }

  return throttled
}
